import { AUTH_INFO_COOKIE, IDENTITY_FLOW_ID } from '../../constants'
import { type Credentials, CredentialsSchema } from '../../entities'
import { isSuperApp } from '@/superapp/use-cases/client'
import { type CookieAttributes, deleteCookie, getCookie, setCookie } from '@/tools/cookies'

export const getCredentials = (): Credentials | null => {
  const value = getCookie(AUTH_INFO_COOKIE)
  if (!value) {
    return null
  }
  const payload = JSON.parse(value)
  return CredentialsSchema.parse(payload)
}

export const setCredentials = (credentials: Credentials) => {
  const payload = CredentialsSchema.parse(credentials)
  const expires = new Date()
  expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000)
  const config: CookieAttributes | undefined = isSuperApp()
    ? {
        secure: true,
        sameSite: 'None',
        expires,
      }
    : undefined
  setCookie(AUTH_INFO_COOKIE, JSON.stringify(payload), config)
}

export const removeCredentials = () => {
  deleteCookie(AUTH_INFO_COOKIE)
}

export const getIdentityFlowId = (): string | null => sessionStorage.getItem(IDENTITY_FLOW_ID)

export const setIdentityFlowId = (id: string) => {
  sessionStorage.setItem(IDENTITY_FLOW_ID, id)
}

export const removeIdentityFlowId = () => {
  sessionStorage.removeItem(IDENTITY_FLOW_ID)
}
